import { Tag } from 'antd';
import type { TaskExecution } from '@/types/taskPlatform';

export function admissionTag(enabled: boolean) {
  return enabled ? <Tag color="green">接单中</Tag> : <Tag>已关闭</Tag>;
}

export function acceptanceTag(value: TaskExecution['acceptance']) {
  return value === 'confirmed' ? (
    <Tag color="green">已确认</Tag>
  ) : (
    <Tag color="gold">未确认</Tag>
  );
}

export function executionStatusTag(value: TaskExecution['executionStatus']) {
  switch (value) {
    case 'SUCCEEDED':
      return <Tag color="green">已完成</Tag>;
    case 'RUNNING':
      return <Tag color="blue">执行中</Tag>;
    case 'FAILED':
      return <Tag color="red">失败</Tag>;
    case 'TIMED_OUT':
      return <Tag color="volcano">已超时</Tag>;
    case 'ABORTED':
      return <Tag>已中止</Tag>;
    case 'PENDING_REDRIVE':
      return <Tag color="gold">等待补送</Tag>;
    default:
      return <Tag color="gold">未知</Tag>;
  }
}

export function outcomeTag(value: TaskExecution['mainOutcome']) {
  switch (value) {
    case 'succeeded':
      return <Tag color="green">成功</Tag>;
    case 'failed':
      return <Tag color="red">失败</Tag>;
    case 'pending':
      return <Tag color="blue">处理中</Tag>;
    default:
      return <Tag color="gold">未知</Tag>;
  }
}

export function deliveryTag(value: TaskExecution['deliveryStatus']) {
  switch (value) {
    case 'succeeded':
      return <Tag color="green">已投递</Tag>;
    case 'failed':
      return <Tag color="red">投递失败</Tag>;
    case 'pending':
      return <Tag color="blue">待投递</Tag>;
    default:
      return <Tag color="gold">未知</Tag>;
  }
}

export function formatTaskTime(value?: string) {
  if (!value) {
    return '—';
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('zh-CN');
}

export function formatTaskDuration(
  startedAt?: string,
  completedAt?: string,
  observedAt?: string,
) {
  if (!startedAt) {
    return '—';
  }
  const started = new Date(startedAt).getTime();
  const completed = completedAt ? new Date(completedAt).getTime() : Number.NaN;
  const observed = observedAt ? new Date(observedAt).getTime() : Number.NaN;
  const hasCompleted = !Number.isNaN(completed);
  const ended = hasCompleted ? completed : observed;
  if (Number.isNaN(started) || Number.isNaN(ended) || ended < started) {
    return '—';
  }

  const totalSeconds = Math.floor((ended - started) / 1000);
  const days = Math.floor(totalSeconds / 86_400);
  const hours = Math.floor((totalSeconds % 86_400) / 3_600);
  const minutes = Math.floor((totalSeconds % 3_600) / 60);
  const seconds = totalSeconds % 60;
  const parts = [
    days ? `${days}天` : '',
    hours ? `${hours}小时` : '',
    minutes ? `${minutes}分` : '',
    seconds || totalSeconds === 0 ? `${seconds}秒` : '',
  ].filter(Boolean);
  const duration = parts.slice(0, 2).join(' ');
  return hasCompleted ? duration : `已运行 ${duration}`;
}
